import React, { useState, FC, useRef, useEffect, ChangeEvent } from "react";
import Container from "../../components/layout/Container/Container";
import Footer from "../../components/molecules/Footer/Footer";
import Header from "../../components/molecules/Header/Header";
import { useNavigate, useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import {
  saveLabApplications,
  saveLabAmendment,
  SavePSHDraftApplications,
  labdeclaration,
  labCalculateFee,
} from "../../api/apimethods";
import { IChooseApp } from "../../typings/models/ChooseApp";
import { IProjectDetails } from "../../typings/models/ProjectDetails";
import { notify } from "../../utils";
import { ErrMsg, NotifyType } from "../../utils/app-config";
import { helper } from "../../utils/helper";
import { IStepwizardProps } from "../../typings/models/StepwizardProps";
import Stepwizard from "./Helper/Stepwizard";
import PersonalInformation from "./Helper/ProfileInformation";
import { SampleData } from "../../typings/models/SampleData";
import {
  ILabSampleModelRequest,
  defAmmendAppStatus,
  defAppStatus,
} from "../../typings/interfaces/Requests/LabSampleModelRequest";
import { IPersonalInfo } from "../../typings/models/PersonalInfo";
import { ILabFeeInput } from "../../typings/interfaces/Requests/LabFeeInput";
import { ILabFeeLineItemInput } from "../../typings/interfaces/Requests/LabFeeLineItemInput";
import { ICalculateFeeResponseModel } from "../../typings/interfaces/Requests/CalculateFeeResponseModel";
import { TypeOfApplicationEnum } from "../../utils/enum";
import {
  IFilerInformation,
  tempFilerInfo,
} from "../../typings/models/FilerInformation";
import { defaultAppContextData } from "../../services/appData";
import { useContextService } from "../../services";
import { defAmendmentRaisedStage } from "../../typings/interfaces/Requests/AquaRequest";
const { message } = notify();
const { btnLoaderHandler, getFilerInfomation, DraftbtnLoaderHandler } =
  helper();
interface PersonalInfo {
  customerName: string;
  mobileNumber: string;
  email: string;
  address: string;
  nric: string;
  homeNumber: string;
  paymentMethod: string;
}

const stepWizardConfig: IStepwizardProps = {
  currentStep: 4,
  steps: [
    {
      name: "Choose Application",
    },
    {
      name: "Samples & Tests",
    },
    {
      name: "Review",
    },
    {
      name: "Cost & Confirm",
    },
    {
      name: "Acknowledgement",
    },
  ],
};

const initialPersonalInfo: PersonalInfo = {
  customerName: "Ramesh",
  mobileNumber: "+65 98765678",
  email: "jeremy.ten@gmail.com",
  address: "30 Sembawang Drive Sun Plaza Singapore 757713",
  nric: "5671",
  homeNumber: "+65 98765678",
  paymentMethod: "GIRO",
};

const CostAndConfirm = () => {
  interface ProjectDetails {
    projectName: string;
    supportDocuments: File | null;
    specialInstructions: string;
    otherRemarks: string;
  }
  interface TestToDisplay {
    testCodeDescription: string;
  }

  interface CompleteApplicationData {
    personalInfo: PersonalInfo;
    samples: SampleData[];
    projectDetails: ProjectDetails;
    typeOfService: string;
    typeOfApplication: string;
    testsToDisplay: TestToDisplay[];
  }

  const navigate = useNavigate();
  const location = useLocation();
  const incomingData = location.state;
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const user = contextData.user;
  const formatDescription = (description: string | null) => {
    if (!description) return "";
    return description
      .replace(/<i>/g, "<em>")
      .replace(/<\/i>/g, "</em>")
      .replace(/<li>/g, "<i>")
      .replace(/<\/li>/g, "</i>");
  };

  const [applicationData, setApplicationData] =
    useState<CompleteApplicationData>({
      personalInfo: initialPersonalInfo,
      samples: incomingData?.samples || [],
      testsToDisplay: incomingData?.testsToDisplay || [],
      projectDetails: {
        projectName: incomingData?.projectName,
        supportDocuments: null,
        specialInstructions: incomingData?.specialInstructions,
        otherRemarks: incomingData?.otherRemarks,
      },
      typeOfService: incomingData?.typeOfServices || "",
      typeOfApplication: incomingData?.typeOfApplication || "",
    });

  useEffect(() => {
    if (location.state) {
      const incomingData = location.state as CompleteApplicationData;
      setApplicationData((prevData) => ({
        ...prevData,
        personalInfo: incomingData.personalInfo || initialPersonalInfo,
        samples: incomingData.samples || [],
        testsToDisplay: incomingData.testsToDisplay || [],
        typeOfService: incomingData.typeOfService || "",
        typeOfApplication: incomingData.typeOfApplication || "",
      }));
    }
  }, [location.state]);

  const handlePreviousClick = () => {
    navigate("/review");
  };
  const [btnNameForLoader, setBtnNameForLoader] = useState<string>("");
  const [ValueLong, setValueLong] = useState<string>("");
  const [applicationType, setApplicationType] = useState("New");
  const [labComFees, setComLabFees] =
    useState<ICalculateFeeResponseModel | null>(null);
  const [btnNameForDraft, setBtnNameForDraft] = useState<string>("");
  const [acknowledgmentNumber, setAcknowledgmentNumber] = useState<string>("");
  let applicationNum = localStorage.getItem("psh-application-no");
  const [acknowledgmentMessage, setAcknowledgmentMessage] = useState<
    string | null
  >(null);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState<boolean>(false);
  let applicationalType = localStorage.getItem("psh-action-type");
  const [isCheckboxEnabled, setIsCheckboxEnabled] = useState(false);
  const handleLoader = (enableLoader: boolean, btnNameOfLoader: string) => {
    setBtnNameForLoader(enableLoader ? btnNameOfLoader : "");
  };
  const handleDraftLoader = (
    enableLoader: boolean,
    btnNameForDraft: string
  ) => {
    setBtnNameForDraft(enableLoader ? btnNameForDraft : "");
  };
  useEffect(() => {
    btnLoaderHandler(btnNameForLoader ? true : false);
  }, [btnNameForLoader]);

  useEffect(() => {
    DraftbtnLoaderHandler(btnNameForDraft ? true : false);
  }, [btnNameForDraft]);
  const contentRef = useRef<HTMLLabelElement>(null);

  const handleScroll = (e: React.UIEvent<HTMLLabelElement>) => {
    const target = e.target as HTMLDivElement;
    const tolerance = 1;
    const isBottom =
      target.scrollTop + target.clientHeight >= target.scrollHeight - tolerance;
    setIsCheckboxEnabled(isBottom);
  };

  useEffect(() => {
    fetchTestCodeMaster();
    fetchLabCalculateFee();
  }, []);
  const fetchTestCodeMaster = async () => {
    try {
      const response = await labdeclaration();

      const valueLong = response.data.valueLong || "";
      setValueLong(valueLong);
    } catch (error) {
      console.error("Error fetching test code master data:", error);
    }
  };

  const fetchLabCalculateFee = async () => {
    try {
      let applicationType = localStorage.getItem("psh-action-type");
      let applicationNum = localStorage.getItem("psh-application-no");

      let applicationTypeText = "New";
      if (applicationType == TypeOfApplicationEnum.amendment) {
        applicationTypeText = TypeOfApplicationEnum.amendment;
      }
      let sampleData = localStorage.getItem("sample-data");
      let sampleDataMeta: SampleData[] = [];

      if (sampleData && sampleData.length) {
        sampleDataMeta = JSON.parse(sampleData);
      }

      if (sampleDataMeta.length) {
        sampleDataMeta.forEach(function (v) {
          delete v?.id;
          delete v.sampleNameOptions;
          delete v.descriptionOptions;
          delete v.sampleDesOptions;
          delete v?.scientificNameOptions;
          delete v?.markingErrMsg;
          delete v?.countryErrMsg;
          delete v?.markingErrMsg;
          delete v?.sampleTypeErrMsg;
          delete v?.signsOrSymptomsErrMsg;
          delete v?.diseaseDistributionErrMsg;
          delete v?.severityErrMsg;
          delete v?.sampleDescErrMsg;
          delete v?.sampleLocationErrMsg;
          delete v?.countryErrMsg;
          delete v?.districtErrMsg;
          delete v?.samplingDateErrMsg;
          delete v?.sampleNameErrMsg;
          delete v?.labTestDetailsErrMsg;
          delete v?.disableDelete;
          v?.labTestDetails?.forEach((element) => {
            delete element?.disableDelete;
          });
        });
      }

      let feeLineItems: ILabFeeLineItemInput[] = [];
      if (sampleDataMeta.length) {
        sampleDataMeta.forEach(function (v) {
          const sampleRowId: number =
            typeof v?.sampleRowId === "number" ? v?.sampleRowId : 0;
          v?.labTestDetails?.forEach((element) => {
            const testRowId = element?.rowId || 0;
            let labFeeLineItemInput: ILabFeeLineItemInput = {
              testCode: element?.testDescription,
              testName: element?.testDescription,
              packageCode: element?.packageName || "",
              packageName: element?.packageName || "",
              sampleName: v?.sampleName || "",

              sampleDescription: v?.sampleDesc || "",
              testCount: element?.Nooftestsrequired ?? 1,
              testrowId: testRowId,
              sampleRowId: sampleRowId,
            };
            feeLineItems.push(labFeeLineItemInput);
          });
        });
      }

      let labFeeInput: ILabFeeInput = {
        transactionType: 1,
        purposeCode: "COM",
        typeofService: "Plant Health Diagnostics Services",
        applicationNumber:
          applicationType === "Submit" || applicationType === "Draft"
            ? ""
            : applicationNum || "",
        applicationType: applicationTypeText,
        feeLineItems: feeLineItems,
      };
      const response = await labCalculateFee(labFeeInput);
      setComLabFees(response.data);
    } catch (error) {
      console.error("Error fetching test code master data:", error);
    }
  };

  const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    setIsCheckboxChecked(isChecked);
    localStorage.setItem("isCheckboxChecked", JSON.stringify(isChecked));
  };
  useEffect(() => {
    const storedCheckboxState = localStorage.getItem("isCheckboxChecked");
    if (storedCheckboxState !== null) {
      setIsCheckboxChecked(JSON.parse(storedCheckboxState));
    }
  }, []);
  const handleContainerClick = () => {
    if (!isCheckboxEnabled) {
      message(
        NotifyType.Error,
        "Please read the complete terms and conditions before checking the checkbox."
      );
    }
  };
  const handleSubmit = async () => {
    try {
      if (!isCheckboxChecked) {
        message(NotifyType.Error, "Please check the declaration checkbox.");
        return;
      }

      handleLoader(true, "submit-req");

      let chooseApp = localStorage.getItem("choose-app");
      let chooseAppMeta: IChooseApp = {
        typeOfApplication: "COM",
        typeOfService: "Plant Health Diagnostics Services",
        applicationType: 0
      };
      let personalInfo: IPersonalInfo = JSON.parse(
        localStorage.getItem("profile-info") || ""
      );

      const applicationType = localStorage.getItem("psh-action-type");

      const applicationNum = localStorage.getItem("psh-application-no");

      if (chooseApp && chooseApp.length) {
        let parsedChooseApp: IChooseApp = JSON.parse(chooseApp);
        chooseAppMeta = {
          ...chooseAppMeta,
          ...parsedChooseApp,
          typeOfApplication: "COM",
        };
      }

      let sampleData = localStorage.getItem("sample-data");
      let sampleDataMeta: SampleData[] = [];

      if (sampleData && sampleData.length) {
        sampleDataMeta = JSON.parse(sampleData);
      }

      let projDetails = localStorage.getItem("lab-project-details") || "";
      const projDetailsMeta: IProjectDetails = JSON.parse(projDetails);

      if (applicationType == "Submit" || applicationType == "Draft") {
        projDetailsMeta.attachment = "";
        projDetailsMeta.attachmentName = "";
        projDetailsMeta.attachmentID = "";
      }

      if (sampleDataMeta.length) {
        sampleDataMeta.forEach(function (v) {
          delete v?.id;
          delete v.sampleNameOptions;
          delete v.sampleDesOptions;
          delete v?.scientificNameOptions;
          delete v?.markingErrMsg;
          delete v?.countryErrMsg;
          delete v?.markingErrMsg;
          delete v?.sampleTypeErrMsg;
          delete v?.signsOrSymptomsErrMsg;
          delete v?.diseaseDistributionErrMsg;
          delete v?.severityErrMsg;
          delete v?.sampleDescErrMsg;
          delete v?.sampleLocationErrMsg;
          delete v?.countryErrMsg;
          delete v?.districtErrMsg;
          delete v?.samplingDateErrMsg;
          delete v?.sampleNameErrMsg;
          delete v?.labTestDetailsErrMsg;
          delete v?.disableDelete;
          v?.labTestDetails?.forEach((element) => {
            delete element?.disableDelete;
          });
        });
      }

      const filerInfo: IFilerInformation | null = getFilerInfomation();
      const meta: ILabSampleModelRequest = {
        labPSHPersonalInfoDetails: personalInfo,
        labPSHChooseApplDetails: chooseAppMeta,
        labPSHSampleTests: sampleDataMeta,
        labPSHPreference: projDetailsMeta,
        actionStatus: applicationType || "",
        applicationNumber: applicationNum || "",
        labPSHFilerInfoDetails: filerInfo || tempFilerInfo,
        labPSHApplicationStatus: defAppStatus,
      };

      let response1;
      const actionedStatus = localStorage.getItem("psh-app-status") || "";
      let amendmentRaisedStage: number | null = null;

      if (actionedStatus && actionedStatus in defAmendmentRaisedStage) {
        amendmentRaisedStage =
          defAmendmentRaisedStage[
            actionedStatus as keyof typeof defAmendmentRaisedStage
          ];
      }

      if (applicationType == TypeOfApplicationEnum.amendment) {
        meta.labPSHPreference.attachment = "";

        meta.labPSHApplicationStatus = {
          ...defAmmendAppStatus,
          actionedStatus,
          amendmentRaisedStage,
        };

        response1 = await saveLabAmendment(meta);
      } else {
        meta.labPSHApplicationStatus = defAppStatus;

        if (applicationType !== TypeOfApplicationEnum.draft) {
          delete meta.applicationNumber;
        } else {
          meta.applicationNumber = applicationNum || "";
        }

        delete meta.actionStatus;
        response1 = await saveLabApplications(meta);
      }

      if (response1.status === 200) {
        const responseJson =
          typeof response1.data === "string"
            ? JSON.parse(response1.data)
            : response1.data;
        const acknowledgmentNumber =
          responseJson?.PSHApplicationNumber ||
          responseJson?.PSHAmendApplicationNumber;
        const applicationDate = responseJson?.ApplicationDate;
        const sampleNames = responseJson?.SampleNames;
        const sampleTypes = responseJson?.SampleTypes;
        const applicantName = responseJson?.ApplicantName;
        const applicantEmail = responseJson?.ApplicantEmail;
        const sampleDescriptions = responseJson?.SampleDescriptions;

        if (acknowledgmentNumber) {
          message(NotifyType.Success, "Request Submitted Successfully");

          localStorage.removeItem("choose-app");
          localStorage.removeItem("lab-project-details");
          localStorage.removeItem("sample-data");
          localStorage.removeItem("psh-action-type");
          localStorage.removeItem("psh-application-no");
          localStorage.removeItem("profile-info");
          localStorage.removeItem("psh-app-status");
          localStorage.removeItem("isCheckboxChecked");
          setTimeout(() => {
            handleLoader(false, "submit-req");
            navigate("/acknowledgement", {
              state: {
                acknowledgmentNumber,
                applicationDate,
                applicantName,
                applicantEmail,
                sampleNames,
                sampleTypes,
                sampleDescriptions,
              },
            });
          }, 5000);
        } else {
          console.error(
            "Acknowledgment number not found in response:",
            response1
          );

          message(NotifyType.Error, "Issue on the request submission.");
          handleLoader(false, "submit-req");
        }
      } else {
        message(NotifyType.Error, "Issue on the request submission.");
        handleLoader(false, "submit-req");
      }
    } catch (error: any) {
      console.error(ErrMsg.InternalServerErrMsg, error);
      message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
      handleLoader(false, "submit-req");
    }
  };
  const handleSaveDraftClick = async () => {
    try {
      handleDraftLoader(true, "submit-request");

      let labApplicationDetails: any = Object.create({});
      let chooseApp: string | null = localStorage.getItem("choose-app");
      let chooseAppMeta: IChooseApp = {
        typeOfApplication: "COM",
        typeOfService: "Plant Health Diagnostics Services",
        applicationType: 0
      };

      if (chooseApp && chooseApp.length) {
        let parsedChooseApp: IChooseApp = JSON.parse(chooseApp);
        chooseAppMeta = {
          ...chooseAppMeta,
          ...parsedChooseApp,
          typeOfApplication: "COM",
        };
      }

      const samplesData = localStorage.getItem("sample-data");
      let sampleDataMeta: SampleData[] = [];

      if (samplesData?.length) {
        sampleDataMeta = JSON.parse(samplesData);
      }
      const projectDetailsData = localStorage.getItem("lab-project-details");
      let projectDetailsDataMeta: any = {};

      if (projectDetailsData?.length) {
        projectDetailsDataMeta = JSON.parse(projectDetailsData);
      }
      let personalInfo: IPersonalInfo = JSON.parse(
        localStorage.getItem("profile-info") || ""
      );

      labApplicationDetails = { ...labApplicationDetails, ...personalInfo };

      const filerInfo: IFilerInformation | null = getFilerInfomation();
      const meta: ILabSampleModelRequest = {
        labPSHChooseApplDetails: chooseAppMeta,
        labPSHSampleTests: sampleDataMeta,
        applicationNumber: applicationNum || "",
        labPSHPersonalInfoDetails: personalInfo,
        labPSHPreference: projectDetailsDataMeta,
        labPSHFilerInfoDetails: filerInfo || tempFilerInfo,
      };
      if (applicationType === TypeOfApplicationEnum.submit) {
        delete meta.applicationNumber;
      }
      const response1 = await SavePSHDraftApplications(meta);

      if (response1.status === 200) {
        const responseData = JSON.parse(response1.data as any);
        const acknowledgmentNumber = responseData?.PSHDraftApplicationNumber;
        message(
          NotifyType.Success,
          acknowledgmentNumber
            ? `Draft Saved Successfully`
            : "Draft Saved Successfully"
        );

        localStorage.setItem("psh-application-no", acknowledgmentNumber);
        setAcknowledgmentMessage(
          acknowledgmentNumber ? `${acknowledgmentNumber}` : ""
        );
        if (applicationType === TypeOfApplicationEnum.submit) {
          localStorage.setItem("psh-action-type", applicationType);
        }
      } else {
        message(NotifyType.Error, "Issue on the request submission.");
        handleDraftLoader(false, "submit-request");
      }
    } catch (error) {
      console.error(ErrMsg.InternalServerErrMsg, error);
      message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
    } finally {
      handleDraftLoader(false, "");
    }
  };

  return (
    <>
      <Header />
      <Container>
        <div className="h1Lab"> Application for Laboratory Testing </div>
        <Stepwizard
          currentStep={stepWizardConfig.currentStep}
          steps={stepWizardConfig.steps}
        />
        <div className="row setup-content" id="step-4">
          <div className="col-md-12">
            <div className="tab-wizard-content">
              {acknowledgmentMessage && (
                <div className="info-content">
                  <div className="att">
                    <h3>Attention</h3>
                    <br />
                    <p className="attention">
                      {">"} Application has been successfully Saved as Draft.
                      Service Acknowledgement Number: &nbsp;
                      {acknowledgmentNumber ? acknowledgmentNumber : ""}
                    </p>
                    {acknowledgmentMessage}
                  </div>
                </div>
              )}
              <PersonalInformation />
            </div>
          </div>
        </div>
        <div className="personal-info">
          <div className="info-heading">
            <h2>Estimation Of Cost</h2>
          </div>

          <div className="info-content ">
            <div className="table-responsive last-bg mt-2 mb-2">
              <table className="table table-striped product_table start_table table-02">
                <thead>
                  <tr>
                    <th>S/N </th>
                    <th>Tests/Services</th>
                    <th>Fee Description</th>
                    <th>Qty</th>
                    {user?.role !== "ForeignerLogin" && <th>Unit Amt (SGD)</th>}
                    {user?.role !== "ForeignerLogin" && <th>GST Amt (SGD)</th>}
                    <th>Net Amt (SGD)</th>
                  </tr>
                </thead>
                <tbody>
                  {/* {labComFees?.applicationType ===
                    TypeOfApplicationEnum.amendment &&
                    labComFees?.originalfeeLineItemsResponse &&
                    labComFees.originalfeeLineItemsResponse.length > 0 && (
                      <tr>
                        <td className="fnt-wg" colSpan={7}>
                          Original
                        </td>
                      </tr>
                    )}
                  {labComFees?.originalfeeLineItemsResponse?.map(
                    (item, index) => (
                      <tr key={index}>
                        <td>{item.sNo}</td>
                        <td
                          dangerouslySetInnerHTML={{
                            __html: formatDescription(
                              item.description2 ? item.description2 : item.name
                            ),
                          }}
                        ></td>
                        <td>{item.description}</td>
                        <td>{item.quantity}</td>
                        {user?.role !== "ForeignerLogin" && (
                          <td>{item.unitAmt?.toFixed(2)}</td>
                        )}
                        {user?.role !== "ForeignerLogin" && (
                          <td>{item.gstAmt?.toFixed(2)}</td>
                        )}
                        <td>{item.netAmt?.toFixed(2)}</td>
                      </tr>
                    )
                  )}

                  {labComFees?.applicationType ===
                    TypeOfApplicationEnum.amendment &&
                    labComFees?.deletedfeeLineItemsResponse &&
                    labComFees.deletedfeeLineItemsResponse.length > 0 && (
                      <tr>
                        <td className="fnt-wg" colSpan={7}>
                          Removed
                        </td>
                      </tr>
                    )}
                  {labComFees?.deletedfeeLineItemsResponse?.map(
                    (item, index) => (
                      <tr key={index}>
                        <td>{item.sNo}</td>
                        <td
                          dangerouslySetInnerHTML={{
                            __html: formatDescription(
                              item.description2 ? item.description2 : item.name
                            ),
                          }}
                        ></td>
                        <td>{item.description}</td>
                        <td>{item.quantity}</td>
                        {user?.role !== "ForeignerLogin" && (
                          <td>{item.unitAmt?.toFixed(2)}</td>
                        )}
                        {user?.role !== "ForeignerLogin" && (
                          <td>{item.gstAmt?.toFixed(2)}</td>
                        )}
                        <td>{item.netAmt?.toFixed(2)}</td>
                      </tr>
                    )
                  )} */}

                  {labComFees?.applicationType ===
                    TypeOfApplicationEnum.amendment &&
                    labComFees?.feeLineItemsResponse &&
                    labComFees.feeLineItemsResponse.length > 0 && (
                      <tr>
                        <td className="fnt-wg" colSpan={7}>
                          Outstanding Payment
                        </td>
                      </tr>
                    )}
                  {labComFees?.feeLineItemsResponse?.map((item, index) => (
                    <tr key={index}>
                      <td>{item.sNo}</td>
                      <td
                        dangerouslySetInnerHTML={{
                          __html: formatDescription(
                            item.description2 ? item.description2 : item.name
                          ),
                        }}
                      ></td>

                      <td>{item.description}</td>
                      <td>{item.quantity}</td>
                      {user?.role !== "ForeignerLogin" && (
                        <td>{item.unitAmt?.toFixed(2)}</td>
                      )}
                      {user?.role !== "ForeignerLogin" && (
                        <td>{item.gstAmt?.toFixed(2)}</td>
                      )}
                      <td>{item.netAmt?.toFixed(2)}</td>
                    </tr>
                  ))}

                  {user?.role !== "ForeignerLogin" && (
                    <tr>
                      <td className="fnt-wg total-fees-payable" colSpan={6}>
                        Total Fees Payable (Before GST)
                      </td>
                      <td className="total-fees-payable">
                        {labComFees?.feesBeforeGST?.toFixed(2)}
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td
                      className="fnt-wg"
                      colSpan={user?.role === "ForeignerLogin" ? 4 : 6}
                    >
                      {user?.role !== "ForeignerLogin"
                        ? "Total GST Payable"
                        : "Total Fees Payable"}
                    </td>
                    <td>
                      {user?.role !== "ForeignerLogin"
                        ? labComFees?.totalGST?.toFixed(2)
                        : labComFees?.feesAfterGST?.toFixed(2)}
                    </td>
                  </tr>
                  {user?.role !== "ForeignerLogin" && (
                    <tr>
                      <td className="fnt-wg" colSpan={6}>
                        Total Fees Payable (After GST)
                      </td>
                      <td>{labComFees?.feesAfterGST?.toFixed(2)}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div
              className="form-check csp-overflow-y-auto"
              onClick={handleContainerClick}
            >
              <input
                className="form-check-input mt-2 csp-w-20-h-20"
                type="checkbox"
                value=""
                id="flexCheckDefault"
                checked={isCheckboxChecked}
                onChange={handleCheckboxChange}
                disabled={!isCheckboxEnabled}
              />
              <label
                htmlFor="flexCheckDefault"
                className="csp-color-black-maxh-200 csp-overflow-y-auto csp-display-block"
                onScroll={handleScroll}
              >
                {ValueLong.split("\n").map((item, index) => (
                  <div key={index} className="csp-mb-5">
                    {item.trim()}
                  </div>
                ))}
              </label>
            </div>
          </div>
        </div>
        <div className="text-end mt-3 mb-3">
          {applicationalType !== TypeOfApplicationEnum.amendment && (
            <button
              className="btn btn-d btn-secondry  px-4"
              onClick={handleSaveDraftClick}
              disabled={btnNameForDraft === "submit-request"}
            >
              {btnNameForDraft === "submit-request"
                ? "Submitting..."
                : "Save Draft"}
            </button>
          )}
          <button
            className="btn btn-d btn-secondary px-4"
            onClick={handlePreviousClick}
          >
            Previous
          </button>
          <button
            className="btn btn-d btn-primary"
            type="button"
            name="submit-req"
            onClick={handleSubmit}
          >
            Submit
            {btnNameForLoader == "submit-req" ? (
              <Spinner
                className="btn-spinner"
                animation="border"
                variant="light"
              />
            ) : (
              ""
            )}
          </button>
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default CostAndConfirm;
